var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownCircle = function SvgArrowDownCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-4.375.624.058-.067a.6.6 0 0 0 .006-.706l-.064-.075-.068-.058a.6.6 0 0 0-.706-.006l-.075.064-2.175 2.175V6.6l-.006-.081a.6.6 0 0 0-.513-.513l-.081-.006-.082.006a.6.6 0 0 0-.513.513l-.005.081v5.352L7.224 9.775l-.067-.058a.6.6 0 0 0-.84.84l.059.067 3.2 3.2.067.059a.6.6 0 0 0 .706.006l.075-.064 3.2-3.2.059-.068-.058.067Z",
    fill: "#666"
  })));
};
export default SvgArrowDownCircle;